import { Box } from '@mui/material';
import type { FieldMode } from '../../../hooks/useCaseField';
import { CaseTextField } from '../../fields';
import PhysicianField from './PhysicianField';

interface PhysicianSectionProps {
  mode: FieldMode;
  company?: string;
  centerId?: string;
  errors?: { [key: string]: string | undefined };
}

const PhysicianSection: React.FC<PhysicianSectionProps> = ({ mode, company = '', centerId = '', errors = {} }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 1.5, mb: 2.5 }}>
    <PhysicianField mode={mode} company={company} centerId={centerId}
      errors={{ physician: errors.physician, npi: errors.npi }} />
    <CaseTextField mode={mode} label="Group"
      getValue={d => d.physicianGroup ?? ''} getUpdate={v => ({ physicianGroup: v })} />
  </Box>
);

export default PhysicianSection;